module.exports = __webpack_public_path__ + "AdobeStock_161673435_shaded4 resized compressed.png?385cee5a0efaf1d2bad332b05c4d61f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_161673435_shaded4 resized compressed.png
// module id = 52
// module chunks = 0